import { NavConfig, TCategoryFeaturedItem } from '@/types/header'
import { Star } from 'lucide-react'

export const navConfig: NavConfig = {
  'nav.category.male': {
    type: 'male',
    href: '/nam',
    sections: [
      {
        title: 'nav.section.all_male_products',
        href: '/collection/do-nam',
        items: [
          {
            title: 'nav.item.new_product',
            href: '/collection/san-pham-moi?gender_type=male',
            className: 'text-primary font-semibold',
          },
          {
            title: 'nav.item.best_seller',
            href: '/collection/ban-chay-nhat?gender_type=male',
            className: 'font-semibold text-neutral-900 hover:text-primary-500',
          },
          {
            title: 'nav.item.explore_our_collection',
            href: '/highlight-collections',
          },
          {
            title: 'nav.item.coolx',
            href: '/graphic-tee?gender_type=male',
          },
        ],
      },
      {
        title: 'nav.section.male_shirts',
        href: '/collection/ao-nam',
        items: [
          {
            title: 'nav.item.male_shirts_all',
            href: '/collection/ao-nam',
          },
          { title: 'nav.item.male_jacket', href: '/collection/ao-khoac-nam' },
          {
            title: 'nav.item.male_long_sleeve_hoodie',
            href: '/collection/ao-dai-tay-hoodies',
          },
          { title: 'nav.item.male_tshirt', href: '/collection/ao-thun-nam' },
          {
            title: 'nav.item.male_polo_shirt',
            href: '/collection/ao-polo-so-mi',
          },
          {
            title: 'nav.item.male_tanktop',
            href: '/collection/ao-ba-lo-tank-top-nam',
          },
          {
            title: 'nav.item.licensed_tee',
            href: '/graphic-tee?gender_type=male',
          },
        ],
      },
      {
        title: 'nav.section.male_pants',
        href: '/collection/quan-nam',
        items: [
          {
            title: 'nav.item.male_pants_all',
            href: '/collection/quan-nam',
          },
          { title: 'nav.item.male_shorts', href: '/collection/quan-short-nam' },
          {
            title: 'nav.item.male_jean_kaki',
            href: '/collection/quan-jeans-kaki',
          },
          {
            title: 'nav.item.male_jogger_pants',
            href: '/collection/quan-jogger-pants',
          },
        ],
      },
      {
        title: 'nav.section.underwear',
        href: '/collection/quan-lot-nam',
        items: [
          {
            title: 'nav.item.male_underwear_all',
            href: '/collection/quan-lot-nam',
          },
          {
            title: 'nav.item.brief',
            href: '/collection/quan-tam-giac-brief',
          },
          {
            title: 'nav.item.trunk',
            href: '/collection/quan-boxer-trunk',
          },
          {
            title: 'nav.item.boxer_brief',
            href: '/collection/quan-boxer-brief-dang-dai',
          },
          {
            title: 'nav.item.long_leg',
            href: '/collection/quan-long-leg',
          },
        ],
      },
      {
        title: 'nav.section.ac_male_accessories',
        href: '/collection/phu-kien-nam',
        items: [],
      },
    ],
    featured: [],
    footer: [
      {
        title: 'nav.footer.by_need',
        items: [
          {
            title: 'nav.footer.casual',
            href: '/collection/do-casual?gender_type=male',
          },
          {
            title: 'nav.footer.homewear',
            href: '/collection/mac-o-nha?gender_type=male',
          },
          {
            title: 'nav.footer.sport_wear',
            href: '/collection/coolmate-activewear',
          },
        ],
      },
    ],
  },
  'nav.category.female': {
    type: 'female',
    href: '/nu',
    sections: [
      {
        title: 'nav.section.all_female_products',
        href: '/collection/coolmate-activewear-nu',
        items: [
          {
            title: 'nav.item.new_product',
            href: '/collection/san-pham-moi?gender_type=female',
            className: 'text-primary font-semibold',
          },
          {
            title: 'nav.item.best_seller',
            href: '/collection/ban-chay-nhat?gender_type=female',
            className: 'font-semibold text-neutral-900 hover:text-primary-500',
          },
          {
            title: 'nav.item.explore_our_collection',
            href: '/highlight-collections',
          },
          {
            title: 'nav.item.coolx',
            href: '/graphic-tee?gender_type=female',
          },
        ],
      },
      {
        title: 'nav.section.female_shirts',
        href: '/collection/ao-nu',
        items: [
          {
            title: 'nav.item.female_shirts_all',
            href: '/collection/ao-nu',
          },
          {
            title: 'nav.item.female_jacket',
            href: '/collection/ao-khoac-nu',
          },
          {
            title: 'nav.item.female_long_sleeve',
            href: '/collection/ao-dai-tay-nu',
          },
          {
            title: 'nav.item.female_tshirt_polo',
            href: '/collection/ao-thun-polo-nu',
          },
          {
            title: 'nav.item.female_bra_singlet',
            href: '/collection/bra-singlet',
          },
          {
            title: 'nav.item.licensed_tee',
            href: '/graphic-tee?gender_type=unisex',
          },
        ],
      },
      {
        title: 'nav.section.female_pants_skirts',
        href: '/collection/quan-nu',
        items: [
          {
            title: 'nav.item.female_pants_all',
            href: '/collection/quan-nu',
          },
          {
            title: 'nav.item.female_jogger_pants',
            href: '/collection/quan-dai-nu',
          },
          {
            title: 'nav.item.female_legging',
            href: '/collection/quan-legging',
          },
          {
            title: 'nav.item.female_shorts',
            href: '/collection/quan-short-nu',
          },
          { title: 'nav.item.female_dress', href: '/collection/vay-dam-nu' },
        ],
      },
      {
        title: 'nav.section.ac_female_accessories',
        href: '/collection/phu-kien-nu',
        items: [],
      },
    ],
    featured: [],
    footer: [
      {
        title: 'nav.footer.by_need',
        items: [
          {
            title: 'nav.footer.casual',
            href: '/collection/do-casual?gender_type=female',
          },
          {
            title: 'nav.footer.homewear',
            href: '/collection/mac-o-nha?gender_type=female',
          },
          {
            title: 'nav.footer.sport_wear',
            href: '/collection/coolmate-activewear-nu',
          },
        ],
      },
    ],
  },
}

export const navConfigCollection = {
  'nav.section.sport': {
    type: 'sport',
    href: '/collection/do-the-thao',
    sections: [
      {
        title: 'nav.section.sport_male',
        href: '/collection/coolmate-activewear?gender_type=male',
        items: [
          {
            title: 'nav.item.male_general_sport',
            href: '/collection/the-thao-chung?gender_type=male',
            img: '/image/2026/10/16/menu-sport-male-general.jpg',
          },
          {
            title: 'nav.item.male_pickleball',
            href: '/collection/pickleball-tennis?gender_type=male',
            img: '/image/2026/10/16/menu-sport-male-pickleball.jpg',
          },
          {
            title: 'nav.item.male_running',
            href: '/collection/quan-ao-chay-bo',
            img: '/image/2026/10/16/menu-sport-male-running.jpg',
          },
          {
            title: 'nav.item.male_gym',
            href: '/collection/quan-ao-phu-kien-tap-gym',
            img: '/image/2026/10/16/menu-sport-male-gym.jpg',
          },
          {
            title: 'nav.item.male_football',
            href: '/collection/quan-ao-da-bong-coolmate',
            img: '/image/2026/10/16/menu-sport-male-football.jpg',
          },
          {
            title: 'nav.item.swimming_sport',
            href: '/collection/do-boi-nam-nu?gender_type=male',
            img: '/image/2026/10/16/menu-sport-male-swimming.jpg',
          },
          {
            title: 'nav.item.badminton',
            href: '/collection/cau-long?gender_type=male',
            img: '/image/2026/10/16/menu-sport-male-badminton.jpg',
          },
        ],
      },
      {
        title: 'nav.section.sport_female',
        href: '/collection/coolmate-activewear-nu?gender_type=female',
        items: [
          {
            title: 'nav.item.female_general_sport',
            href: '/collection/the-thao-chung-nu',
            img: '/image/2026/10/16/menu-sport-female-general.jpg',
          },
          {
            title: 'nav.item.female_pickleball',
            href: '/collection/pickleball-tennis?gender_type=female',
            img: '/image/2026/10/16/menu-sport-female-pickleball.jpg',
          },
          {
            title: 'nav.item.female_running',
            href: '/collection/quan-ao-chay-bo-nu',
            img: '/image/2026/10/16/menu-sport-female-running.jpg',
          },
          {
            title: 'nav.item.female_yoga',
            href: '/collection/yoga-pilates',
            img: '/image/2026/10/16/menu-sport-female-yoga.jpg',
          },
          {
            title: 'nav.item.female_gym',
            href: '/collection/quan-ao-phu-kien-tap-gym-nu',
            img: '/image/2026/10/16/menu-sport-female-gym.jpg',
          },
          {
            title: 'nav.item.swimming_sport',
            href: '/collection/do-boi-nam-nu?gender_type=female',
            img: '/image/2026/10/16/menu-sport-female-swimming.jpg',
          },
          {
            title: 'nav.item.badminton',
            href: '/collection/cau-long?gender_type=female',
            img: '/image/2026/10/16/menu-sport-female-badminton.jpg',
          },
        ],
      },
    ],
    featured: [],
    footer: [
      {
        title: 'nav.footer.highlight',
        items: [
          {
            title: 'Hoàng Sao x Coolmate',
            href: '/collection/bst-the-martian',
          },
          {
            title: 'nav.footer.seamless_motion',
            href: '/collection/seamless-motion',
          },
          {
            title: 'nav.footer.safe_in_the_dark',
            href: '/collection/run-safe-in-the-dark',
          },
          {
            title: 'nav.footer.zeromark',
            href: '/collection/zero-mark-collection',
          },
        ],
      },
    ],
  },
}

export const navConfigAccessories = {
  'nav.category.accessories': {
    type: 'accessories',
    href: '/collection/phu-kien',
    sections: [
      {
        title: 'nav.section.all_accessories',
        href: '/collection/phu-kien',
        items: [
          {
            title: 'nav.item.new_accessories',
            href: '/collection/phu-kien?sort=new',
          },
          {
            title: 'nav.item.accessories_best_seller',
            href: '/collection/phu-kien?sort=bestseller',
          },
          {
            title: 'nav.item.amazon_best_seller',
            href: '/collection/amazon-best-seller',
            className: 'font-bold text-neutral-600',
          },
        ],
      },
      {
        title: 'nav.section.ac_male_accessories',
        href: '/collection/phu-kien-nam',
        items: [
          {
            title: 'nav.item.ac_male_accessories_all',
            href: '/collection/phu-kien-nam',
          },
          {
            title: 'nav.item.male_bags',
            href: '/collection/tui-cac-loai',
          },
          { title: 'nav.item.male_hats_caps', href: '/collection/mu-non-nam' },
          {
            title: 'nav.item.male_socks',
            href: '/collection/tat-vo-nam',
          },
          {
            title: 'nav.item.male_wallets_belts',
            href: '/collection/vi-that-lung',
          },
          {
            title: 'nav.item.male_running_masks',
            href: '/collection/mat-na-chay-bo',
          },
          {
            title: 'nav.item.male_cup',
            href: '/collection/ly-coc',
          },
          {
            title: 'nav.item.male_other_accessories',
            href: '/collection/phu-kien-khac',
          },
        ],
      },
      {
        title: 'nav.section.ac_female_accessories',
        href: '/collection/phu-kien-nu',
        items: [
          {
            title: 'nav.item.ac_female_accessories_all',
            href: '/collection/phu-kien-nu',
          },
          {
            title: 'nav.item.female_bags',
            href: '/collection/tui-nu',
          },
          {
            title: 'nav.item.female_hats_caps',
            href: '/collection/mu-non-nu',
          },
          {
            title: 'nav.item.female_socks',
            href: '/collection/tat-vo-nu',
          },
          {
            title: 'nav.item.female_other_accessories',
            href: '/collection/phu-kien-nu-khac',
          },
        ],
      },
    ],
    featured: [],
  },
}

export const navConfigCareAndShare = {
  type: 'care_and_share',
  title: 'nav.care_and_share.title',
  description: 'nav.care_and_share.description',
  imageStep: 'nav.care_and_share.image_step',
  imageStepAlt: 'nav.care_and_share.image_step_alt',
  href: '/collection/care-and-share',
  image: '/image/March2025/mceclip0_226.jpg',
  imageMobile: '/image/February2025/mceclip0_55.png',
  imageAlt: 'nav.care_and_share.ao_am_cho_em',
  buttonText: 'nav.care_and_share.title',
  specialCollections: [
    {
      title: 'nav.care_and_share.ao_am_cho_em',
      href: '/collection/ao-am-cho-em',
      img: '/image/October2024/mceclip0_9.png',
    },
    {
      title: 'nav.care_and_share.vun_art',
      href: '/collection/vun-art-du-an-chung-tay-xay-nha-moi',
      img: '/image/July2024/mceclip0_156.jpg',
    },
    {
      title: 'nav.care_and_share.cung_hoang_dao',
      href: '/collection/cung-hoang-dao-collection',
      img: '/image/May2024/mceclip2_33.png',
    },
  ],
}

export const menuMobileConfig = {
  menu: {
    'nav.category.male': {
      type: 'male',
      button: {
        text: 'nav.mobile.explore_male',
        href: '/nam',
      },
      sections: [
        {
          title: 'nav.section.autumn_winter',
          items: [
            {
              title: 'nav.item.autumn_winter',
              href: '/collection/do-thu-dong',
              className: 'text-primary-500',
            },
          ],
        },
        {
          title: 'nav.section.outlet_male',
          items: [
            {
              title: 'nav.item.outlet_male',
              href: '/collection/giam-gia?gender_type=male',
              className: 'text-error-500',
            },
          ],
        },
        {
          title: 'nav.section.highlight',
          items: [
            { title: 'nav.section.all_products', href: '/collection/do-nam' },
            {
              title: 'nav.item.new_product',
              href: '/collection/san-pham-moi?gender_type=male',
              className: 'text-primary font-semibold',
            },
            {
              title: 'nav.item.best_seller',
              href: '/collection/ban-chay-nhat?gender_type=male',
            },
            {
              title: 'nav.item.explore_our_collection',
              href: '/highlight-collections',
            },
          ],
        },
        {
          title: 'nav.section.male_shirts',
          items: [
            { title: 'nav.item.all_male_shirts', href: '/collection/ao-nam' },
            { title: 'nav.item.male_jacket', href: '/collection/ao-khoac-nam' },
            {
              title: 'nav.item.male_long_sleeve_hoodie',
              href: '/collection/ao-dai-tay-hoodies',
            },
            { title: 'nav.item.male_tshirt', href: '/collection/ao-thun-nam' },
            {
              title: 'nav.item.male_polo_shirt',
              href: '/collection/ao-polo-so-mi',
            },
            {
              title: 'nav.item.male_tanktop',
              href: '/collection/ao-ba-lo-tank-top-nam',
            },
            {
              title: 'nav.item.licensed_tee',
              href: '/graphic-tee?gender_type=male',
            },
          ],
        },
        {
          title: 'nav.section.male_pants',
          items: [
            { title: 'nav.item.all_male_pants', href: '/collection/quan-nam' },
            {
              title: 'nav.item.male_shorts',
              href: '/collection/quan-short-nam',
            },
            {
              title: 'nav.item.male_jean_kaki',
              href: '/collection/quan-jeans-kaki',
            },
            {
              title: 'nav.item.male_jogger_pants',
              href: '/collection/quan-jogger-pants',
            },
          ],
        },
        {
          title: 'nav.section.male_underwear',
          items: [
            {
              title: 'nav.item.all_male_underwear',
              href: '/collection/quan-lot-nam',
            },
            {
              title: 'nav.item.brief',
              href: '/collection/quan-tam-giac-brief',
            },
            {
              title: 'nav.item.trunk',
              href: '/collection/quan-boxer-trunk',
            },
            {
              title: 'nav.item.boxer_brief',
              href: '/collection/quan-boxer-brief-dang-dai',
            },
            {
              title: 'nav.item.long_leg',
              href: '/collection/quan-long-leg',
            },
          ],
        },
        {
          title: 'nav.section.male_accessories',
          items: [
            {
              title: 'nav.item.all_accessories',
              subtitle: 'nav.item.accessories_description',
              href: '/collection/phu-kien-nam',
            },
          ],
        },
        {
          title: 'nav.section.buy_by_need',
          items: [
            {
              title: 'nav.item.casual',
              href: '/collection/do-casual?gender_type=male',
            },
            {
              title: 'nav.item.homewear',
              href: '/collection/mac-o-nha?gender_type=male',
            },
            {
              title: 'nav.item.sport_wear',
              href: '/collection/coolmate-activewear',
            },
          ],
        },
      ],
      featured: [] as TCategoryFeaturedItem[],
    },
    'nav.category.female': {
      type: 'female',
      button: {
        text: 'nav.mobile.explore_female',
        href: '/nu',
      },
      sections: [
        {
          title: 'nav.section.autumn_winter',
          items: [
            {
              title: 'nav.item.autumn_winter',
              href: '/collection/do-thu-dong',
              className: 'text-primary-500',
            },
          ],
        },
        {
          title: 'nav.section.outlet_female',
          items: [
            {
              title: 'nav.item.outlet_female',
              href: '/collection/giam-gia?gender_type=female',
              className: 'text-error-500',
            },
          ],
        },
        {
          title: 'nav.section.highlight',
          items: [
            {
              title: 'nav.section.female_all_products',
              href: '/collection/coolmate-activewear-nu',
            },
            {
              title: 'nav.item.new_product',
              href: '/collection/san-pham-moi?gender_type=female',
              className: 'text-primary font-semibold',
            },
            {
              title: 'nav.item.best_seller',
              href: '/collection/ban-chay-nhat?gender_type=female',
            },
            {
              title: 'nav.item.explore_our_collection',
              href: '/highlight-collections',
            },
          ],
        },
        {
          title: 'nav.section.female_shirts',
          items: [
            { title: 'nav.item.female_all_shirts', href: '/collection/ao-nu' },
            {
              title: 'nav.item.female_jacket',
              href: '/collection/ao-khoac-nu',
            },
            {
              title: 'nav.item.female_long_sleeve',
              href: '/collection/ao-dai-tay-nu',
            },
            {
              title: 'nav.item.female_tshirt_polo',
              href: '/collection/ao-thun-polo-nu',
            },
            {
              title: 'nav.item.female_bra_singlet',
              href: '/collection/bra-singlet',
            },
            {
              title: 'nav.item.licensed_tee',
              href: '/graphic-tee?gender_type=unisex',
            },
          ],
        },
        {
          title: 'nav.section.female_pants',
          items: [
            { title: 'nav.item.female_all_pants', href: '/collection/quan-nu' },
            {
              title: 'nav.item.female_jogger_pants',
              href: '/collection/quan-dai-nu',
            },
            {
              title: 'nav.item.female_legging',
              href: '/collection/quan-legging',
            },
            {
              title: 'nav.item.female_shorts',
              href: '/collection/quan-short-nu',
            },
            { title: 'nav.item.female_dress', href: '/collection/vay-dam-nu' },
          ],
        },
        {
          title: 'nav.section.female_accessories',
          items: [
            {
              title: 'nav.item.socks',
              href: '/collection/tat-vo-nu',
            },
            {
              title: 'nav.item.bags_other_accessories',
              href: '/collection/phu-kien-nu-khac',
            },
          ],
        },
        {
          title: 'nav.section.buy_by_need',
          items: [
            {
              title: 'nav.item.casual',
              href: '/collection/do-casual?gender_type=female',
            },
            {
              title: 'nav.item.homewear',
              href: '/collection/mac-o-nha?gender_type=female',
            },
            {
              title: 'nav.item.sport_wear',
              href: '/collection/coolmate-activewear-nu',
            },
          ],
        },
      ],
      featured: [] as TCategoryFeaturedItem[],
    },
    'nav.section.sport': {
      type: 'sport',
      button: undefined,
      sections: [
        {
          title: 'nav.section.sport_male',
          items: [
            {
              title: 'nav.item.male_general_sport',
              href: '/collection/the-thao-chung?gender_type=male',
            },
            {
              title: 'nav.item.male_pickleball',
              href: '/collection/pickleball-tennis?gender_type=male',
            },
            {
              title: 'nav.item.male_running',
              href: '/collection/quan-ao-chay-bo',
            },
            {
              title: 'nav.item.male_gym',
              href: '/collection/quan-ao-phu-kien-tap-gym',
            },
            {
              title: 'nav.item.male_football',
              href: '/collection/quan-ao-da-bong-coolmate',
            },
            {
              title: 'nav.item.badminton',
              href: '/collection/cau-long?gender_type=male',
            },
            {
              title: 'nav.item.swimming_sport',
              href: '/collection/do-boi-nam-nu?gender_type=male',
            },
          ],
        },
        {
          title: 'nav.section.sport_female',
          items: [
            {
              title: 'nav.item.female_general_sport',
              href: '/collection/the-thao-chung-nu',
            },
            {
              title: 'nav.item.female_pickleball',
              href: '/collection/pickleball-tennis?gender_type=female',
            },
            {
              title: 'nav.item.female_running',
              href: '/collection/quan-ao-chay-bo-nu',
            },
            {
              title: 'nav.item.female_yoga',
              href: '/collection/yoga-pilates',
            },
            {
              title: 'nav.item.badminton',
              href: '/collection/cau-long?gender_type=female',
            },
            {
              title: 'nav.item.swimming_sport',
              href: '/collection/do-boi-nam-nu?gender_type=female',
            },
          ],
        },
        {
          title: 'nav.section.explore_bst',
          items: [
            {
              title: 'Hoàng Sao x Coolmate',
              href: '/collection/bst-the-martian',
            },
            {
              title: 'nav.item.seamless_motion',
              href: '/collection/seamless-motion',
            },
            {
              title: 'nav.item.safe_in_the_dark',
              href: '/collection/run-safe-in-the-dark',
            },
            {
              title: 'nav.item.zeromark',
              href: '/collection/zero-mark-collection',
            },
          ],
        },
      ],
      featured: [] as TCategoryFeaturedItem[],
    },
  },
  footer: {
    menu: [
      {
        title: 'nav.mobile.footer.stores',
        href: '/stores?itm_source=navbar',
        className: 'font-bold text-neutral-900',
      },
      {
        title: 'nav.mobile.footer.coolclub',
        icon: Star,
        className: 'font-bold text-primary-500 [&_svg]:fill-primary-500',
        href: '/coolclub',
      },
      {
        title: 'nav.mobile.footer.cskh',
        href: '/page/trung-tam-dich-vu-khach-hang?itm_source=navbar',
      },
      { title: 'nav.mobile.footer.about', href: '/page/coolmate-story' },
      {
        title: 'nav.mobile.footer.recruit',
        href: '/lp/coolmate-101?itm_source=footer',
      },
      { title: 'nav.mobile.footer.login', href: '/login' },
      { title: 'nav.mobile.footer.blog', href: '/blog' },
    ],
  },
}
